import React from 'react';
import { Card, Tag, Typography } from 'antd';
import type { paydOrder } from '../../interfaces';
import AdminOrdersItems from '../AdminOrdersItems';
import {
  formatAddress,
  formatCurrency,
  formatDate,
  getShortOrderId,
} from './adminOrdersCard.utils';
import './AdminOrdersCard.scss';

const { Text } = Typography;

interface AdminOrdersCardProps {
  order: paydOrder;
  isShippingOpen: boolean;
  onCopyOrderId: (orderId: string) => void;
  onToggleShipping: (orderId: string) => void;
}

const AdminOrdersCard: React.FC<AdminOrdersCardProps> = ({
  order,
  isShippingOpen,
  onCopyOrderId,
  onToggleShipping,
}) => (
  <Card className="admin-orders__card">
    <div className="admin-orders__card-top">
      <div className="admin-orders__customer">
        <Text type="secondary" className="admin-orders__label">
          Customer
        </Text>
        <Text strong>{order.user?.name || 'Unknown customer'}</Text>
        <Text className="admin-orders__customer-email">{order.user?.email || '—'}</Text>
      </div>
      <div className="admin-orders__summary">
        <Text type="secondary" className="admin-orders__label">
          Order
        </Text>
        <Text strong>{formatCurrency(order.totalAmount)}</Text>
        <div className="admin-orders__order-id-row">
          <Text className="admin-orders__order-id">{getShortOrderId(order.id)}</Text>
          <button
            type="button"
            className="admin-orders__copy-id-btn"
            onClick={() => onCopyOrderId(order.id)}
          >
            Copy ID
          </button>
        </div>
        <div className="admin-orders__summary-main">
          <Text type="secondary">{formatDate(order.paymentDate)}</Text>
        </div>
        <Tag color={order.status === 'PAID' ? 'green' : 'gold'}>{order.status || 'PAID'}</Tag>
        <Text type="secondary">{order.paymentMethod || 'Stripe'}</Text>
        <Text type="secondary">Items: {order.items?.length || 0}</Text>
      </div>
    </div>
    <div className="admin-orders__card-body">
      <div className="admin-orders__section admin-orders__shipping-section">
        <button
          type="button"
          className="admin-orders__shipping-toggle"
          onClick={() => onToggleShipping(order.id)}
          aria-expanded={isShippingOpen}
          aria-controls={`shipping-address-${order.id}`}
        >
          <Text type="secondary" className="admin-orders__label">
            Shipping address
          </Text>
          <Text className="admin-orders__shipping-arrow">
            {isShippingOpen ? 'Hide' : 'Show'}
          </Text>
        </button>
        <div
          id={`shipping-address-${order.id}`}
          className={`admin-orders__shipping-content${isShippingOpen ? ' is-open' : ''}`}
        >
          <Text className="admin-orders__address">{formatAddress(order)}</Text>
        </div>
      </div>
      <div className="admin-orders__section">
        <Text type="secondary" className="admin-orders__label">
          Items
        </Text>
        <AdminOrdersItems items={order.items} />
      </div>
    </div>
  </Card>
);

export default AdminOrdersCard;
